import { SVGProps } from 'react';

const HomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.333 15.833a1.667 1.667 0 1 0-3.333 0 1.667 1.667 0 0 0 3.333 0ZM15 4.167a1.667 1.667 0 1 0-3.333 0 1.667 1.667 0 0 0 3.333 0ZM8.333 4.167a1.667 1.667 0 1 0-3.333 0 1.667 1.667 0 0 0 3.333 0ZM5 10a1.667 1.667 0 1 0-3.333 0A1.667 1.667 0 0 0 5 10ZM15 15.833a1.667 1.667 0 1 0-3.333 0 1.667 1.667 0 0 0 3.333 0ZM11.667 10a1.667 1.667 0 1 0-3.334 0 1.667 1.667 0 0 0 3.334 0ZM18.333 10A1.667 1.667 0 1 0 15 10a1.667 1.667 0 0 0 3.333 0ZM5 10h3.333M11.667 10H15M12.5 5.833l-1.667 2.5M7.5 5.833l1.667 2.5M9.167 11.667l-1.667 2.5M10.833 11.667l1.667 2.5"
    />
  </svg>
);

export default HomeIcon